import type { Theme } from "../store/uiStore";

export interface HeaderPalette {
  bg:           string;
  border:       string;
  logo:         string;   // primary text colour (logo, drill button, value)
  statLabel:    string;   // small uppercase stat labels
  statValue:    string;
  statHighlight:string;   // attention-grabbing value (e.g. fire count > 0)
  buttonBg:     string;
  buttonBorder: string;
  icon:         string;
}

const DARK: HeaderPalette = {
  bg:            "#111827",
  border:        "#374151",
  logo:          "#f9fafb",
  // Bumped from #6b7280 → #d1d5db so 10-px uppercase labels stay legible
  // against the near-black header background.
  statLabel:     "#d1d5db",
  statValue:     "#f9fafb",
  statHighlight: "#fbbf24",
  buttonBg:      "#1f2937",
  buttonBorder:  "#4b5563",
  icon:          "#fbbf24",
};

const LIGHT: HeaderPalette = {
  bg:            "#ffffff",
  border:        "#e5e7eb",
  logo:          "#111827",
  statLabel:     "#4b5563",
  statValue:     "#111827",
  statHighlight: "#b45309",
  buttonBg:      "#f9fafb",
  buttonBorder:  "#d1d5db",
  icon:          "#1d4ed8",
};

export function headerPalette(theme: Theme): HeaderPalette {
  return theme === "light" ? LIGHT : DARK;
}
